import { render, staticRenderFns } from "./RewardsLevels.vue?vue&type=template&id=0cf33b36"
import script from "./RewardsLevels.vue?vue&type=script&lang=js"
export * from "./RewardsLevels.vue?vue&type=script&lang=js"
import style0 from "./RewardsLevels.vue?vue&type=style&index=0&id=0cf33b36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports